import TreeTable from './tree-table.vue'

export default TreeTable